export const usernameInitial = (fname='', lname='') => {
    return fname.charAt(0) + lname.charAt(0);
}